<section-header
    sectionTitle="Academic Program Review - Reviewer Dashboard"
    navPath="/review"
    containerClass="container"
    [navLinks]="[]"></section-header>
<div class="alert alert-info"  *ngIf="hasInstructions()">
    <span [innerHTML]="getInstructions()"></span>	
</div>
<span> 
    <div class="form-inline pl-4" *ngIf="currentUser.value.roles.academicHumanResources; else nonAHR">
        <span class="mr-2"><strong>Review Cycle:</strong></span>
        <select class="form-control" style="min-width: 200px;" [(ngModel)]="selectedAHRYear" (change)="refreshComponent(selectedAHRYear)">
            <option value="ALL">ALL</option>
            <option value="2029">2029-2030</option>
            <option value="2028">2028-2029</option>
            <option value="2027">2027-2028</option>
            <option value="2026">2026-2027</option>
            <option value="2025">2025-2026</option>
            <option value="2024">2024-2025</option>
            <option value="2023">2023-2024</option>
            <option value="2022">2022-2023</option>
        </select>
    </div>
    <ng-template #nonAHR>
        <div class="pl-4" >
            <strong>Review Cycle: </strong>{{ getReviewRange(selectedAHRYear) }}
        </div>
    </ng-template>
    <hr/>
</span>

<div id="wrapper" class="container-fluid">
    <div class="row">
        <div class="col-lg-4 mb-3">
            <reviewer-case-list *ngIf="showCaseList" [selectedAHRYear]="selectedAHRYear"></reviewer-case-list>
        </div>
        <div class="col-md-12 col-lg-8">
			<router-outlet></router-outlet>
        </div>
    </div>
</div>